"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthClient = void 0;
var superappkit_1 = require("@vkontakte/superappkit");
var constants_1 = require("./constants");
var domofon_1 = require("./domofon");
var AuthClient = /** @class */ (function () {
    function AuthClient(props) {
        // TODO Ассоциировать Origins с нужными скоупами
        var DEFAULT_SOURCE_ORIGINS_WHITELIST = [window.location.origin];
        var DEFAULT_AUTH_PROVIDER_URL = 'https://auth.tutoria.ru/iframe';
        this.props = __assign({ authProviderUrl: DEFAULT_AUTH_PROVIDER_URL, originsWhitelist: DEFAULT_SOURCE_ORIGINS_WHITELIST }, props);
    }
    AuthClient.prototype.insert = function () {
        var container = this.props.container;
        var authProviderParsedUrl = this.getAuthProviderParsedUrl();
        if (!container) {
            throw new Error('"container" prop required for provider mount');
        }
        this.authIframe = document.createElement('iframe');
        this.authIframe.style.position = 'absolute';
        this.authIframe.style.border = 'none';
        this.authIframe.style.width = '0';
        this.authIframe.style.height = '0';
        this.authIframe.dataset['testId'] = 'auth-provider-iframe';
        container.appendChild(this.authIframe); // запихиваем iframe в DOM, чтобы появился contentWindow
        authProviderParsedUrl.searchParams.append('parent_origin', window.location.origin);
        authProviderParsedUrl.searchParams.append('origins', this.props.originsWhitelist.join(','));
        this.authIframe.src = authProviderParsedUrl.toString();
    };
    AuthClient.prototype.init = function (callbacks) {
        var _a, _b;
        var origin = (_a = this.getAuthProviderParsedUrl()) === null || _a === void 0 ? void 0 : _a.origin;
        this.domofon = new domofon_1.Domofon(__assign({ source: {
                origins: [origin],
            }, target: {
                origin: origin,
                window: ((_b = this.authIframe) === null || _b === void 0 ? void 0 : _b.contentWindow) || undefined,
            } }, callbacks));
    };
    AuthClient.prototype.onMessage = function () { };
    AuthClient.prototype.handshake = function () {
        var _this = this;
        var _a = this.props, onError = _a.onError, needMountProvider = _a.needMountProvider;
        if (!needMountProvider) {
            this.init({ onMessage: this.onMessage, onError: onError });
            return Promise.resolve();
        }
        return new Promise(function (resolve) {
            var _a;
            _this.insert();
            _this.init({ onMessage: _this.onMessage, onError: onError });
            (_a = _this.domofon) === null || _a === void 0 ? void 0 : _a.subscribe('tutoria-auth-provider:ready', function () {
                var _a;
                (_a = _this.domofon) === null || _a === void 0 ? void 0 : _a.request({ name: 'tutoria-auth-client:handshake' }, 'tutoria-auth-provider:handshake', '').then(function (message) {
                    resolve(message);
                });
            });
        });
    };
    AuthClient.prototype.getShortToken = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var paramsForLongAuth, parsedUrl, payload, stateFromRedirectLogin, _c, token, uuid, state;
            var _this = this;
            return __generator(this, function (_d) {
                paramsForLongAuth = null;
                parsedUrl = new URL(window.location.href);
                payload = parsedUrl.searchParams.get('payload');
                stateFromRedirectLogin = parsedUrl.searchParams.get('state');
                if (payload) {
                    _c = JSON.parse(payload), token = _c.token, uuid = _c.uuid, state = _c.state;
                    paramsForLongAuth = {
                        silentToken: token,
                        silentUUID: uuid,
                        csrf_token: state || stateFromRedirectLogin,
                    };
                    parsedUrl.searchParams.delete('payload');
                    parsedUrl.searchParams.delete('state');
                    (_a = window === null || window === void 0 ? void 0 : window.history) === null || _a === void 0 ? void 0 : _a.replaceState({}, '', parsedUrl.toString());
                }
                // запрашиваем у фрейма шотр-токен
                return [2 /*return*/, (_b = this.domofon) === null || _b === void 0 ? void 0 : _b.request({ name: 'tutoria-auth-client:short', payload: paramsForLongAuth }, 'tutoria-auth-provider:short').then(function (message) {
                        var _a, _b;
                        if (!((_a = message === null || message === void 0 ? void 0 : message.payload) === null || _a === void 0 ? void 0 : _a.token) && _this.props.vkIdConfig) {
                            // запрашиваем у VKID silent-token и uuid, происходит редирект
                            superappkit_1.Config.init({
                                appId: _this.props.vkIdConfig.appId,
                            });
                            superappkit_1.Autologin.autologinRedirect({
                                autologin_delay: 0.05,
                                url: _this.props.vkIdConfig.redirectUrl,
                                state: (_b = message === null || message === void 0 ? void 0 : message.payload) === null || _b === void 0 ? void 0 : _b.state,
                                callback: function (_result) {
                                    var _a;
                                    if (!_this.props.vkIdConfig) {
                                        return;
                                    }
                                    superappkit_1.Connect.redirectAuth({
                                        url: _this.props.vkIdConfig.redirectUrl,
                                        state: (_a = message === null || message === void 0 ? void 0 : message.payload) === null || _a === void 0 ? void 0 : _a.state,
                                    });
                                },
                            });
                            throw message;
                        }
                        return message === null || message === void 0 ? void 0 : message.payload;
                    })];
            });
        });
    };
    AuthClient.prototype.getExchangeToken = function (username, scope) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, (_a = this.domofon) === null || _a === void 0 ? void 0 : _a.request({ name: 'tutoria-auth-client:exchange', payload: { username: username, scope: scope } }, 'tutoria-auth-provider:exchange').then(function (message) {
                        return message === null || message === void 0 ? void 0 : message.payload;
                    })];
            });
        });
    };
    AuthClient.prototype.request = function (message) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, (_a = this.domofon) === null || _a === void 0 ? void 0 : _a.request({ name: "".concat(constants_1.clientMessagePrefix).concat(message) }, "".concat(constants_1.providerMessagePrefix).concat(message)).then(function (message) {
                        // if (message.source && !this.domofon.prosp.source.window) {
                        // 	TODO: should we set domofon.props.source.window = message.source ?
                        // }
                        return message === null || message === void 0 ? void 0 : message.payload;
                    })];
            });
        });
    };
    AuthClient.prototype.getAuthProviderParsedUrl = function () {
        return new window.URL(this.props.authProviderUrl);
    };
    return AuthClient;
}());
exports.AuthClient = AuthClient;
//# sourceMappingURL=client-side.js.map